import { Link } from "react-router-dom";

interface FAQItem {
  question: string;
  answer: string;
}

interface OpenFAQProps {
  faqs: FAQItem[];
  title?: string;
}

export const OpenFAQ = ({ faqs, title = "Häufig gestellte Fragen" }: OpenFAQProps) => {
  return (
    <section className="my-12" id="faq">
      <h2 className="text-3xl font-bold text-foreground mb-8">{title}</h2>
      <div className="space-y-8">
        {faqs.map((faq, index) => (
          <article key={index} className="border-b border-border pb-6 last:border-b-0">
            <h2 className="text-xl md:text-2xl font-semibold text-foreground mb-3">
              {faq.question}
            </h2>
            <div
              className="text-muted-foreground leading-relaxed prose prose-sm max-w-none"
              dangerouslySetInnerHTML={{ __html: faq.answer }}
            />
          </article>
        ))}
      </div>
    </section>
  );
};
